import { Typography, Button } from '@mui/material';
import { Box, styled } from '@mui/system';
import { Colors, ColorsV2 } from 'app/constants/color';

const CustomPageHeader = styled(Box)({
  width: '95%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginRight: '1em',
});

const CustomButton = styled(Button)({
  backgroundColor: 'black',
  borderRadius: '8px',
  height: '5vh',
  '&:hover': {
    backgroundColor: 'black',
    boxShadow: 'none',
  },
});

const CustomButtonDiv = styled(Box)({
  border: '2px solid #E2E3E5',
  borderRadius: '8px',
  height: '36px',
  marginLeft: '6px',
  width: '220px',
  display: 'flex',
});

const CustomButtonDiv2 = styled(Box)({
  borderRadius: '8px',
  height: '40px',
  width: '40px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const Title = styled(Typography)({
  fontFamily: 'DM Sans, sans-serif',
  fontWeight: 700,
  fontSize: '1em',
  textTransform: 'uppercase',
  color: ColorsV2.white,
});

const CustomTableContainer = styled(Box)({
  marginTop: '2em',
  backgroundColor: ColorsV2.secondary,
  border: `1px solid ${ColorsV2.outline}`,
  width: '95%',
  alignItems: 'center',
  borderRadius: '0px',
  marginBottom: '2rem',
});

const CustomTableHeader = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  borderRadius: '8px',
  padding: '0.5em',
  alignItems: 'center',
  justifyContent: 'space-between',
});

const CustomSearchDiv = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '25vw',
});

const CustomButtonsContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row-reverse',
  alignItems: 'center',
  width: '10%',
});

const CustomTableHeading = styled(Typography)({
  color: Colors.pageHeading_icon,
  marginRight: '6px',
});

const DeleteButton = styled(Box)({
  border: `1px solid ${ColorsV2.white}`,
  color: ColorsV2.white,
  borderRadius: '100px',
  marginLeft: '10px',
  padding: '2px 10px',
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: ColorsV2.acent,
  },
});

export {
  CustomButtonDiv,
  CustomButtonDiv2,
  CustomTableContainer,
  CustomTableHeader,
  CustomSearchDiv,
  CustomButtonsContainer,
  CustomPageHeader,
  CustomButton,
  CustomTableHeading,
  Title,
  DeleteButton,
};
